module.exports = __webpack_public_path__ + "static/media/shop-primary.c3265932.svg";